import { CSSProperties } from 'react'

import { ParameterPropertyType } from '@types'

export const convertParameterPropertiesToCssProperties = (
  parameters: ParameterPropertyType[]
): CSSProperties => {
  const cssProperties: Record<string, string | number | undefined> = {}

  parameters.forEach(parameter => {
    if (parameter.value !== null) {
      switch (parameter.key) {
        case 'alignment':
          cssProperties['textAlign'] = parameter.value as CSSProperties['textAlign']
          cssProperties['justifyContent'] = parameter.value as CSSProperties['textAlign']
          break
        case 'isBold':
          cssProperties['fontWeight'] = parameter.value === 'true' ? 'bold' : 'normal'

          break
        case 'isItalic':
          cssProperties['fontStyle'] = parameter.value === 'true' ? 'italic' : 'normal'

          break
        case 'fontColor':
          cssProperties['color'] = parameter.value

          break
        case 'bgFontColor':
          if (parameter.value !== 'none') {
            cssProperties['backgroundColor'] = parameter.value
          }

          break
        case 'borderColor':
          if (parameter.value !== 'none') {
            cssProperties['border'] = `1px solid ${parameter.value}`
          }

          break
        case 'fontSize':
          cssProperties['fontSize'] = `${parameter.value}px`

          break
        default:
          cssProperties[parameter.key] = parameter.value
      }
    }
  })

  return cssProperties
}
